import { CeruleanButton } from 'components/Button'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { validator } from 'utils'

import Container from '../Modal/Container'
import Footer from '../Modal/Footer'

type Props = WrappedComponentProps & {
  steps: number
  valid: boolean
}

const Ssn = ({ intl, steps, valid }: Props) => (
  <>
    <Container
      current={steps - 1}
      sub={intl.formatMessage(messages.sub_title_ssn)}
      title={intl.formatMessage(messages.title_ssn)}
      total={steps}
      theme='dark'
    >
      <InputContainer>
        <Field
          autoComplete='new-password'
          component={Input}
          data-lpignore='true'
          e2e='newPasswordInput'
          focus
          label={intl.formatMessage(messages.label_ssn)}
          maxLength={50}
          name='ssn'
          showPassword
          type='password'
          validate={[validator.required]}
        />
      </InputContainer>

      <CeruleanButton disabled={!valid} e2e='continueButton' type='submit'>
        {intl.formatMessage(messages.button_continue)}
      </CeruleanButton>
    </Container>

    <Footer>
      <Text color='dark200'>{intl.formatMessage(messages.next_veriff)}</Text>
    </Footer>
  </>
)

export default injectIntl(Ssn)
